import '../css/app.css';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';
import { createI18n } from 'vue-i18n';
import { ZiggyVue } from 'ziggy-js';
import { initializeTheme } from './composables/useAppearance';

import en from '@assets/i18n/en.json';
import fr from '@assets/i18n/fr.json';
import cleanTextDirective from './directives/cleanText';

const appName = import.meta.env.VITE_APP_NAME || 'CERAMO';

export const i18n = createI18n({
  legacy: false,
  locale: 'fr',
  devTools: false,
  missing: (locale, key) => {
    console.warn(`[i18n missing] ${locale}: ${key}`);
  },
  fallbackWarn: true,
  missingWarn: true,
  fallbackLocale: 'fr',
  messages: {
    en,
    fr,
  },
});

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
  setup({ el, App, props, plugin }) {
    // Workaround pour fixer les problèmes de HMR sous Docker
    if (window.__inertiaApp) {
      window.__inertiaApp.unmount();
    }
    const app = createApp({ render: () => h(App, props) });
    app.use(plugin).use(i18n).use(ZiggyVue);

    app.directive('clean-text', cleanTextDirective);

    window.__inertiaApp = app;
    app.mount(el);
  },
  progress: {
    color: '#4B5563',
  },
});

// This will set light / dark mode on page load...
initializeTheme();
